module.exports = __webpack_public_path__ + "img/k-chat-icon.f121c54d.png";